/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Classroomdiscipline200,
  GetApiV1Classroomdiscipline401,
  GetApiV1Classroomdiscipline500,
  GetApiV1ClassroomdisciplineQueryParams,
  GetApiV1ClassroomdisciplineQueryResponse,
} from "../../types/classPlanningController/GetApiV1Classroomdiscipline.ts";
import { classroomDisciplineListItemViewModelSchema } from "../classroomDisciplineListItemViewModelSchema.ts";
import { eClassRoomDisciplinesStatusSchema } from "../eClassRoomDisciplinesStatusSchema.ts";

export const getApiV1ClassroomdisciplineQueryParamsSchema = z
  .object({
    CompanyId: z.optional(z.coerce.number().int()),
    CourseId: z.optional(z.coerce.number().int()),
    ClassStudentId: z.optional(z.coerce.number().int()),
    ClassModuleId: z.optional(z.coerce.number().int()),
    DisciplineId: z.optional(z.coerce.number().int()),
    PoloId: z.optional(z.coerce.number().int()),
    Status: z.optional(
      z.array(
        z
          .lazy(() => eClassRoomDisciplinesStatusSchema)
          .describe(
            "1 = Planned | 2 = Finished | 3 = Canceled | 4 = Confirmed | ",
          ),
      ),
    ),
    DateStart: z.optional(z.string().datetime()),
    DateEnd: z.optional(z.string().datetime()),
    Teacher: z.optional(z.string()),
    SortField: z.optional(z.string()),
    SortDirection: z.optional(z.string()),
    PageNumber: z.optional(z.coerce.number().int()),
    PageSize: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Classroomdiscipline200Schema = z.array(
  z.lazy(() => classroomDisciplineListItemViewModelSchema),
) as unknown as ToZod<GetApiV1Classroomdiscipline200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Classroomdiscipline401Schema =
  z.any() as unknown as ToZod<GetApiV1Classroomdiscipline401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Classroomdiscipline500Schema =
  z.any() as unknown as ToZod<GetApiV1Classroomdiscipline500>;

export const getApiV1ClassroomdisciplineQueryResponseSchema = z.lazy(
  () => getApiV1Classroomdiscipline200Schema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineQueryResponse>;
